import { gql } from "@apollo/client";

export const GET_UNIDADES_SOPORTE = gql`
query QUnidadSoporte {
    unidadSoporte
        {
            success,
            error,
            valorEsperado {
                id,
                descripcion,
                abreviacion
            }
        }
}`;